import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import { useStyleStore } from "@bloglovin/vue-component-library";

export default class ButtonBorderColor extends BaseOption {
  static userInterfaceComponent = {
    label: "Border Color",
    component: inspectorTools.COLOR_PICKER,
    props: {
      width: "fill",
      colorContext: "Borders",
    },
  };

  static defaultValue = {
    source: "theme.border",
    value: "none",
  };

  static convertConfigValueToCompiledValue(configValue, themeId, themeMode = "inherit") {
    const styleStore = useStyleStore();
    let palette = styleStore.themePalettes[themeId];

    if (configValue.source.includes("semantic")) {
      palette = styleStore.getSemanticPaletteFromMode(themeId, themeMode);
    }
    return BaseOption.getColorValue(configValue, styleStore.themes[themeId], palette, themeId, themeMode);
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return compiledValue.value;
  }
}
